export default "__VITE_ASSET__0QMSN1v3__"